<template>
    <v-container>
        <v-row>
            <v-col cols="12" lg="4">
                <v-select
                    v-model="request.requestTypeId"
                    :items="requestTypes"
                    item-value="id"
                    no-data-text="Nie znaleziono typu zapotrzebowania"
                    :error-messages="requestTypeIdErrors"
                    label="Typ zapotrzebowania"
                    required
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12" lg="4">
                <v-select
                    v-if="action === 'updateRequest'"
                    v-model=" request.statusId"
                    :items="requestStatuses"
                    item-value="id"
                    no-data-text="Nie znaleziono statusu"
                    label="Status"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="3">
                <v-text-field
                    v-model="request.title"
                    :readonly="action === 'updateRequest'"
                    label="Tytuł"
                    :error-messages="requestTitleErrors"
                    required
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-textarea
                    v-model="request.content"
                    name="Opis"
                    label="Opis"
                    :error-messages="requestContentErrors"
                    required
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'Details',
    mixins: [ tooltipDelay ],
    props: {
        request: {
            type: Object,
            default: null
        },
        validations: {
            type: Object,
            default: null
        },
        action: {
            type: String,
            default: null
        },
    },
    computed: {
        requestTypes() {
            return this.$store.state.purchases.requests.requestTypes
        },
        requestStatuses() {
            return this.$store.state.purchases.requests.requestStatuses
        },
        requestTypeIdErrors() {
            const errors = []

            if (!this.validations.request.requestTypeId.$dirty) return errors
            !this.validations.request.requestTypeId.required && errors.push('Typ zapotrzebowania jest wymagany.')

            return errors
        },
        requestTitleErrors() {
            const errors = []

            if (!this.validations.request.title.$dirty) return errors
            !this.validations.request.title.required && errors.push('Tytuł jest wymagany.')

            return errors
        },
        requestContentErrors() {
            const errors = []

            if (!this.validations.request.content.$dirty) return errors
            !this.validations.request.content.required && errors.push('Opis jest wymagany.')

            return errors
        },
    },
}
</script>